import { render, staticRenderFns } from "./TotalAmountsBase.vue?vue&type=template&id=3e11a248&scoped=true&"
import script from "./TotalAmountsBase.vue?vue&type=script&lang=js&"
export * from "./TotalAmountsBase.vue?vue&type=script&lang=js&"
import style0 from "./TotalAmountsBase.vue?vue&type=style&index=0&id=3e11a248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e11a248",
  null
  
)

export default component.exports